import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import { companyInfo } from '../data/siteData';
import { imageUrl } from '../lib/images';

export default function FacaderPage() {
  return (
    <>
      <SEO
        title="Facader – et flot og holdbart udtryk | Hovendals"
        description="Kvalitetsfacader tilpasset dine ønsker Vi arbejder med materialer i høj kvalitet og tilpasser altid løsningen til bygningens stil og dine ønsker. Uanset om du drømmer om en moderne facade med et strømlinet look eller en klassisk løsning med varme naturmaterialer, kan vi skabe et resultat, der fremhæver ejendommens udtryk og værdi. Med en facade fra Hovendals får du ikke blot et smukt ydre, men også en solid investering i fremtidens komfort og beskyttelse. Smukke facader, der holder i mange år"
        ogImage="/_assets/fece.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/fece.jpg", "width=1600,quality=80,format=auto")}
            alt="Facader"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-building" aria-hidden="true"></i>
              <span>Kvalitetsfacader</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              En facade, der holder
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Facaden er dit hjems eller din virksomheds førstehåndsindtryk – og derfor er det vigtigt, at den både ser indbydende ud og kan holde til det danske vejr. Hos Hovendals tilbyder vi facadeløsninger, der kombinerer æstetik, funktionalitet og holdbarhed.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Tilpasset dine ønsker</span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight mt-1">
                  Kvalitetsfacader tilpasset dine ønsker
                </h2>
              </div>
              <p className="text-slate-700 leading-relaxed text-base">
                Vi arbejder med materialer i høj kvalitet og tilpasser altid løsningen til bygningens stil og dine ønsker. Uanset om du drømmer om en moderne facade med et strømlinet look eller en klassisk løsning med varme naturmaterialer, kan vi skabe et resultat, der fremhæver ejendommens udtryk og værdi.
              </p>
              <p className="text-slate-700 leading-relaxed text-base">
                Med en facade fra Hovendals får du ikke blot et smukt ydre, men også en solid investering i fremtidens komfort og beskyttelse.
              </p>

              <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                <h3 className="font-bold text-slate-900 text-sm uppercase tracking-wider mb-3">
                  Smukke facader, der holder i mange år
                </h3>
                <ul className="space-y-2.5 text-sm text-slate-700 font-medium">
                  <li className="flex items-start gap-2">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>Materialer i høj kvalitet – altid tilpasset bygningens stil og dine ønsker</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>Mulighed for både moderne, strømlinede facader og klassiske løsninger med naturmaterialer</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>Design, der fremhæver ejendommens udtryk og værdi</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>En facade, der kombinerer æstetik med holdbarhed</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>En investering i fremtidens komfort og beskyttelse</span>
                  </li>
                </ul>
              </div>

              <div className="flex flex-wrap gap-4 pt-2">
                <a
                  href={`tel:${companyInfo.phoneFormatted}`}
                  className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring: {companyInfo.phone}</span>
                </a>
                <Link
                  to="/kontakt"
                  className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-paper-plane" aria-hidden="true"></i>
                  <span>Få et uforpligtende tilbud</span>
                </Link>
                <Link
                  to="/vinduespartier"
                  className="px-6 py-3 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-900 font-semibold text-sm transition-all flex items-center gap-2"
                >
                  <span>Se vinduespartier</span>
                  <i className="fa-sharp fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
                </Link>
              </div>
            </div>

            <div className="space-y-6">
              <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white bg-slate-100">
                <img
                  src={imageUrl("/_assets/fece.jpg", "width=800,quality=85,format=auto")}
                  alt="Facade arbejde"
                  className="w-full h-auto object-cover"
                />
              </div>

              <div className="relative rounded-2xl overflow-hidden shadow-lg border-4 border-white bg-slate-100">
                <img
                  src={imageUrl("/_assets/udestue.webp", "width=800,quality=85,format=auto")}
                  alt="Udestue og overdækning"
                  className="w-full h-auto aspect-[16/10] object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />
    </>
  );
}
